import React, { Component } from "react";
import "./about.css";
import Fade from 'react-reveal/Fade'; // Importing Zoom effect

export default class About extends Component {
  render() {
    return (
      <div id="about">
        <div className="text-center about_part">
          <Fade left>
          <div className="about text-left">
            <h2 className="about_title text-left">Hi I'm Ahmet</h2>
            <h2 className="about_title text-left about_title2">
              Software Student
            </h2>
            <div>
              <p className="about_text">
              
              I am a 2nd-year software student and concentrates on web and game development. I'm trying to increase my experience on react.js, which is from the javascript library and unity which is game engine.

              </p>
              <h2 className="about_title text-left about_title2">
              Some Projects
            </h2>
            <a href="https://movieking.netlify.com/" target="_blank" rel="noreferrer" className="about_text text-dark" style={{cursor:"pointer"}}>https://movieking.netlify.com/</a>
            </div>
          </div>
          </Fade>
          
        </div>
      </div>
    );
  }
}
